module.exports = __webpack_public_path__ + "media/img/frontend_application/promo-blank-0927cb7ff6e87657154e6b7735dde296.png";